import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class NarratorSpeak extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            locale: appHelper.getLocalData(this.props.dialog)
        };

        this.showResponse = this.showResponse.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.onComplete = this.onComplete.bind(this);
    }

    componentDidMount() {
        this.showResponse();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.props.dialog)
            });
        }
    }

    showResponse() {
        let objectRef = this.refs[`narratorSpeak_${this.props.index}`];
        TweenLite.set(objectRef, {height: "auto"});
        TweenLite.from(objectRef, objectConstants.SPEECH_BUBBLE_DURATION, {
            height: 0,
            ease: Expo.easeInOut,
            delay: this.props.delay
        }).eventCallback("onComplete", this.onComplete);
    }

    onComplete() {
        this.handleProgression();
    }

    handleProgression() {
        this.props.callbacks.onObjectComplete(this.props.index);
    }

    render() {
        return (
            <div className="object-container-conversation" ref={`narratorSpeak_${this.props.index}`}>
                <div dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
            </div>

        );
    }
}

NarratorSpeak.propTypes = {
    asset_id: PropTypes.number.isRequired,
    option_id: PropTypes.number,
    index: PropTypes.number.isRequired,
    dialog: PropTypes.object.isRequired,
    delay: PropTypes.number.isRequired,
    callbacks: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

NarratorSpeak.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        trackingData: state.trackingData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NarratorSpeak);



/** WEBPACK FOOTER **
 ** ./src/components/objects/conversationDialog/NarratorSpeak.js
 **/